import { useState, useEffect } from "react";

export default function CustomCookieBanner() {
  const [visible, setVisible] = useState(false);
  const [showManage, setShowManage] = useState(false);
  const [tab, setTab] = useState("preferences"); // "preferences" | "about"
  const [preferences, setPreferences] = useState({
    necessary: true,
    analytics: false,
    marketing: false,
  });

  useEffect(() => {
    const accepted = localStorage.getItem("cookiesAccepted");
    if (!accepted) {
      setTimeout(() => setVisible(true), 1000);
    } else {
      const saved = localStorage.getItem("cookiePreferences");
      if (saved) setPreferences(JSON.parse(saved));
    }
  }, []);

  const acceptAll = () => {
    const prefs = { necessary: true, analytics: true, marketing: true };
    savePreferences(prefs);
    setVisible(false);
  };

  const declineAll = () => {
    const prefs = { necessary: true, analytics: false, marketing: false };
    savePreferences(prefs);
    setVisible(false);
  };

  const savePreferences = (prefs) => {
    localStorage.setItem("cookiesAccepted", "true");
    localStorage.setItem("cookiePreferences", JSON.stringify(prefs));
    setPreferences(prefs);
    setShowManage(false);
  };

  if (!visible) return null;

  return (
    <>
      {/* Banner */}
      <div
        className="fixed bottom-4 left-1/2 -translate-x-1/2 w-full sm:w-[600px]
       bg-white  rounded-2xl p-5 z-50 flex flex-col sm:flex-row items-center 
       justify-between gap-4 shadow-md"
      >
        <div>
          <h1 className="text-lg font-medium text-gray-700 text-left mb-2">
            Our site uses cookies
          </h1>
          <p className="text-sm text-gray-700 text-left">
            We use cookies to personalize your experience with us (the digital
            kind, not the delicious baked goods). By clicking "Accept All",
            you're letting us know you're okay with that.
          </p>
        </div>

        <div className="flex w-full justify-around gap-2">
          <button
            onClick={acceptAll}
            className="px-4 py-2 w-full rounded-full bg-pink-500 text-white text-sm "
          >
            Accept All
          </button>
          <button
            onClick={() => {
              setShowManage(true);
              setTab("preferences");
            }}
            className="px-4 py-2 w-full rounded-full border border-pink-500 text-pink-500 text-sm "
          >
            Manage
          </button>
        </div>
      </div>

      {/* Slide-up Manage Panel */}
      <div
        className={`fixed bottom-0 left-0 w-full h-[90vh] bg-white z-50 shadow-xl transform transition-transform duration-300
        ${showManage ? "translate-y-0" : "translate-y-full"} flex flex-col`}
      >
        {/* Header with tabs */}
        <div className="flex justify-between items-center border-b border-gray-300 p-4">
          <h2 className="text-lg font-semibold">Cookie Settings</h2>
          <button
            onClick={() => setShowManage(false)}
            className="text-gray-500 font-bold text-xl"
          >
            &times;
          </button>
        </div>

        <div className="flex border-b border-gray-300">
          <button
            onClick={() => setTab("preferences")}
            className={`flex-1 py-2 text-center font-medium ${
              tab === "preferences"
                ? "border-b-2 border-pink-500 text-pink-500"
                : "text-gray-600"
            }`}
          >
            Preferences
          </button>
          <button
            onClick={() => setTab("about")}
            className={`flex-1 py-2 text-center font-medium ${
              tab === "about"
                ? "border-b-2 border-pink-500 text-pink-500"
                : "text-gray-600"
            }`}
          >
            About
          </button>
        </div>

        {/* Content */}
        <div className="p-4 flex-1 overflow-y-auto">
          {tab === "preferences" ? (
            <div className="flex flex-col gap-4">
              {/* Strictly Necessary */}
              <div className="flex flex-col gap-1">
                <label className="flex items-center gap-2">
                  <input type="checkbox" checked disabled />
                  <span className="font-semibold">Strictly Necessary</span>
                </label>
                <p className="text-gray-600 text-sm">
                  These cookies are essential for the website to function and
                  cannot be switched off.
                </p>
              </div>

              {/* Analytics */}
              <div className="flex flex-col gap-1">
                <label className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    checked={preferences.analytics}
                    onChange={(e) =>
                      setPreferences({
                        ...preferences,
                        analytics: e.target.checked,
                      })
                    }
                  />
                  <span className="font-semibold">Analytics</span>
                </label>
                <p className="text-gray-600 text-sm">
                  Analytics cookies help us understand how visitors interact
                  with our website.
                </p>
              </div>

              {/* Marketing */}
              <div className="flex flex-col gap-1">
                <label className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    checked={preferences.marketing}
                    onChange={(e) =>
                      setPreferences({
                        ...preferences,
                        marketing: e.target.checked,
                      })
                    }
                  />
                  <span className="font-semibold">Marketing</span>
                </label>
                <p className="text-gray-600 text-sm">
                  Marketing cookies are used to provide personalized ads and
                  improve your experience.
                </p>
              </div>

              <button
                onClick={() => savePreferences(preferences)}
                className="mt-4 px-4 py-2 rounded-full bg-pink-500 text-white hover:shadow-[0_0_8px_#ff66b3,0_0_16px_#ff66b3] transition"
              >
                Save Preferences
              </button>
            </div>
          ) : (
            <div className="flex flex-col gap-4">
              <h3 className="font-semibold text-lg">About Cookies</h3>
              <p className="text-gray-700 text-sm">
                Cookies are small text files that are stored in your web browser
                that allows us or a third party to recognize you. Cookies can be
                used to collect, store and share bits of information about your
                activities across websites, including on Lovi’s Website and Web
                Application.
              </p>

              <p className="text-gray-700 text-sm">
                It enables the website to remember your actions and preferences
                (such as login, language, font size and other display
                preferences) over a period of time, so you don’t have to keep
                re-entering them whenever you come back to the site or browse
                from one page to another.
              </p>


              <h4 className="font-semibold mt-4">Services We Use</h4>
              <p className="text-gray-700 text-sm">
                We use several trusted third-party services to improve your
                experience and operate our platform:
              </p>

              <ul className="list-disc pl-5 text-gray-700 text-sm">
                <li>
                  <strong>Amplitude</strong> — used for product analytics and
                  session replay to understand how users interact with our
                  website and improve usability.
                </li>
                <li>
                  <strong>Google Analytics</strong> — helps us collect
                  anonymized statistics about page views and user behavior to
                  enhance our service quality.
                </li>
                <li>
                  <strong>Facebook Pixel</strong> — used for marketing
                  attribution and measuring the effectiveness of our ad
                  campaigns.
                </li>
                <li>
                  <strong>Stripe</strong> — our secure payment processor, which
                  may use necessary cookies to handle checkout and prevent
                  fraud.
                </li>
                <li>
                  <strong>Session Replay</strong> (via Amplitude plugin) —
                  records anonymized user sessions to identify usability issues
                  and improve user experience. Sensitive data (like payment
                  info) is never recorded.
                </li>
              </ul>

              <p className="text-gray-700 text-sm mt-3">
                You can manage which categories of cookies (Analytics and
                Marketing) you allow in the "Preferences" tab. Essential cookies
                required for security and payments (such as Stripe) cannot be
                disabled.
              </p>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
